export default __webpack_public_path__ + "static/media/dark1.33e5d1b8.png";